/**
 * Gemlay cart compatibility loader.
 * Loads the preserved original Standard Actions integration, then installs a
 * synchronized cart-drawer renderer so the first add-to-cart always paints
 * current line items before the drawer opens.
 */
(function gemlayCartCompatibilityLoader() {
  if (window.__gemlayCartCompatibilityLoader) return;
  window.__gemlayCartCompatibilityLoader = true;

  const current = document.currentScript;

  function installDrawerSync() {
    customElements
      .whenDefined('cart-drawer')
      .then(() => {
        const DrawerClass = customElements.get('cart-drawer');
        if (!DrawerClass || DrawerClass.prototype.__gemlaySynchronizedRender) return;
        DrawerClass.prototype.__gemlaySynchronizedRender = true;

        DrawerClass.prototype.renderContents = async function renderGemlaySynchronizedContents(parsedState) {
          const parseSection = (html, selector = '.shopify-section') => {
            if (!html) return null;
            try {
              return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
            } catch (_) {
              return null;
            }
          };

          this.productId = parsedState?.id;
          this.querySelector('.drawer__inner')?.classList.remove('is-empty');

          for (const section of this.getSectionsToRender?.() || []) {
            const mount = section.selector
              ? document.querySelector(section.selector)
              : document.getElementById(section.id);
            const source = parseSection(
              parsedState?.sections?.[section.id],
              section.selector || '.shopify-section',
            );
            if (mount && source) mount.innerHTML = source.innerHTML;
          }

          const cartBase = String(window.routes?.cart_url || '/cart').replace(/\/$/, '');
          let cart = null;

          try {
            const response = await fetch(`${cartBase}.js?gemlay_sync=${Date.now()}`, {
              credentials: 'same-origin',
              cache: 'no-store',
              headers: {
                Accept: 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
              },
            });
            if (response.ok) cart = await response.json();
          } catch (_) {}

          if ((cart?.item_count > 0 || parsedState?.id) && !this.querySelector('.cart-item')) {
            try {
              const response = await fetch(
                `${cartBase}?section_id=cart-drawer&gemlay_sync=${Date.now()}`,
                {
                  credentials: 'same-origin',
                  cache: 'no-store',
                  headers: { 'X-Requested-With': 'XMLHttpRequest' },
                },
              );

              if (response.ok) {
                const html = await response.text();
                const freshDocument = new DOMParser().parseFromString(html, 'text/html');
                const freshDrawer = freshDocument.querySelector('#CartDrawer');
                const targetDrawer = this.querySelector('#CartDrawer');

                if (freshDrawer && targetDrawer) {
                  targetDrawer.innerHTML = freshDrawer.innerHTML;
                }
              }
            } catch (error) {
              console.error('[Gemlay] Fresh cart drawer fallback failed.', error);
            }
          }

          const isEmpty = cart
            ? Number(cart.item_count || 0) === 0
            : !this.querySelector('.cart-item');

          this.classList.toggle('is-empty', isEmpty);
          this.querySelector('.drawer__inner')?.classList.toggle('is-empty', isEmpty);
          this.querySelector('cart-drawer-items')?.classList.toggle('is-empty', isEmpty);

          const overlay = this.querySelector('#CartDrawer-Overlay');
          if (overlay) overlay.onclick = () => this.close();

          this.open();
        };
      })
      .catch((error) => {
        console.error('[Gemlay] Cart drawer synchronization patch failed.', error);
      });
  }

  if (!current?.src) {
    installDrawerSync();
    return;
  }

  const originalUrl = new URL(current.src, window.location.href);
  originalUrl.pathname = originalUrl.pathname.replace(
    /standard-actions-override\.js$/,
    'standard-actions-override-original.js',
  );
  originalUrl.search = '';
  originalUrl.hash = '';

  const original = document.createElement('script');
  original.src = originalUrl.toString();
  original.async = false;
  original.onload = installDrawerSync;
  original.onerror = () => {
    console.error('[Gemlay] Could not load preserved Standard Actions integration.');
    installDrawerSync();
  };

  current.parentNode?.insertBefore(original, current.nextSibling);
})();
